import type { Role } from '@agentwiki/shared'
import { isSourceBackedDocument } from './document-kind'
import { getSafeDocumentReturnTarget } from './document-return-continuity'

export interface DocumentRouteTarget {
  id: string
  slug?: string | null
  sourceProvenance?: unknown | null
}

export function documentReadPath(doc: DocumentRouteTarget): string {
  return doc.slug ? `/doc/${doc.slug}` : `/doc/id/${doc.id}`
}

export function documentEditPath(doc: DocumentRouteTarget): string {
  return `${documentReadPath(doc)}/edit`
}

export function canEditDocument(doc: DocumentRouteTarget, role: Role | null): boolean {
  return !isSourceBackedDocument(doc) && (role === 'admin' || role === 'editor')
}

export function getSafeDocumentReturnPath(state: unknown): string {
  return getSafeDocumentReturnTarget(state).href
}
